export const customAttributeIncluded = "Included";
export const customAttributeNotIncluded = "Not Included";
export const customAttributeWorking = "Working";
export const customAttributeBroken = "Broken";
